import Repository, { MarketingRepository } from './Repository'

const endpoint = 'cms'

const token = '8c7c8876451374b1978bcbd8167e427e'
const tokenIdWebSafe = 'ahZzfnN0dW5uaW5nLWJhc2UtMTY0NDAycl4LEgVDVXNlciIkZTc2MGUxYmMtMDBlMi00ZGU2LWEwZGYtNDk5OGNiOGEzNDBjDAsSBVRva2VuIiRmODlhNjUwMi05MmJjLTRiYWEtODlhNi1hMGU2MjEwYjY0ZWEM'

export default {
    get(typeBanner = 'MAIN_BANNER', category = 0, idCluster = 0) {
        return Repository.get(`${endpoint}/getBannersCMS?web=true&type=${typeBanner}&allBanners=true&category=${category}`, { params: { token, tokenIdWebSafe, directionBanner: false } })
    },
    getBannersByCluster(id, typeBanner = 'MAIN_BANNER') {
        return Repository.get(`${endpoint}/getBannersCMS?web=true&type=${typeBanner}&allBanners=true&cluster=${id}`, { params: { token, tokenIdWebSafe, directionBanner: false } })
    },
    insert(payload) {
        return Repository.post(`${endpoint}/insertBanner`, payload)
    },
    edit(payload) {
        return Repository.post(`${endpoint}/editBanner`, payload)
    },
    delete(id) {
        return Repository.post(`${endpoint}/deleteBanner`, { id: id })
    },
    updateOrder(orderList) {
        return Repository.post(`${endpoint}/updateOrderBanner`, { listBanner: orderList })
    },
    getBannerById(id) {
        return MarketingRepository.get(`${endpoint}/${id}`)
    },
    updatePinned(id, isPinned) {
        return MarketingRepository.post(`${endpoint}/${id}/pinned`, { isPinned: isPinned ? '1' : '0' })
    },
    getLastBanner() {
        return MarketingRepository.get(`${endpoint}/last`)
    },
}